module.exports = __webpack_public_path__ + "static/media/vg.68763b7f.svg";